import {Button, Dropdown, Form, Input, TextArea} from "semantic-ui-react";
import {IItem} from "../../interfaces/Item";
import {rotationAngles, round} from "../../utils/constants";
import { useTranslation } from "react-i18next";
import {useCallback, useRef, useState} from "react";

interface Props {
  style: any;
  selectedItem: IItem;
  pxInMM: number;
  setOpenFontModal: (open: boolean) => void;
  onChangeWithStyle: (propName: string, propValue: any, propNameStyle: string, propValueStyle: any) => void;
  onChange: (propName: string, propValue: any) => void;
}

export const SimpleTextForm = ({style, selectedItem, pxInMM, setOpenFontModal, onChangeWithStyle, onChange}: Props) => {
  const {t} = useTranslation();
  return (
    <Form style={style.form}>
      <Form.Field>
        <label style={{textAlign: "left"}}>{t("static_text")}:</label>
        <TextArea rows={2} value={selectedItem.value} placeholder={t("enter_static_text")} onChange={(e) => onChange("value", e.target.value)} />
      </Form.Field>
      <Form.Field inline style={style.field}>
        <label>{t("x_from")}:</label>
        <Input
          fluid
          size="small"
          style={{width: "100%"}}
          type="number"
          value={round(selectedItem.xInMM)}
          onChange={(e) => {
            onChangeWithStyle("xInMM", Number(e.target.value), "left", `${Number(e.target.value) * pxInMM}px`);
          }}
        />
      </Form.Field>
      <Form.Field inline style={style.field}>
        <label>{t("y_from")}:</label>
        <Input
          fluid
          size="small"
          style={{width: "100%"}}
          type="number"
          value={round(selectedItem.yInMM)}
          onChange={(e) => {
            onChangeWithStyle("yInMM", Number(e.target.value), "top", `${Number(e.target.value) * pxInMM}px`);
          }}
        />
      </Form.Field>
      <Form.Field inline style={style.field}>
        <label>{t("width")}:</label>
        <Input
          fluid
          size="small"
          style={{width: "100%"}}
          type="number"
          value={round(selectedItem.width)}
          onChange={(e) => {
            onChange("width", Number(e.target.value));
          }}
        />
      </Form.Field>
      <Form.Field inline style={style.field}>
        <label>{t("rotation")}:</label>
        <Dropdown
          size="small"
          options={rotationAngles}
          value={Number(selectedItem.rotation)}
          fluid
          selection={true}
          search={(options, query) => 
            options.filter((option) => 
              option.text?.toString().toLowerCase().includes(query.toLowerCase()) || 
              option.value?.toString().toLowerCase().includes(query.toLowerCase())
            )
          }
          onChange={(e, data) => {
            onChangeWithStyle("rotation", Number(data.value), "transform", `rotate(${data.value}deg)`);
          }}
        />
      </Form.Field>
      <Form.Field inline style={style.field}>
        <label></label>
        <Button size="small" compact onClick={() => setOpenFontModal(true)} type="button">
        {t("font_btn")}
        </Button>
      </Form.Field>
      <Form.Field inline style={style.field}>
        {/* <label>{t("bring_to_back")}:</label>
        <Form.Checkbox
          checked={selectedItem.bringBack === 1 ? true : false}
          onChange={(e, data) => {
            onChange("bringBack", selectedItem.bringBack === 1 ? 2 : 1);
          }}
        /> */}
        <Button
          compact fluid basic
          onClick={() => {
            onChange("bringBack", selectedItem.bringBack === 1 ? 2 : 1);
          }}
        >
          {t("bring_to_back")}
        </Button>
      </Form.Field>
    </Form>
  );
};
